
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/foerderung",
      function () {
        return require("private-next-pages/foerderung/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/foerderung"])
      });
    }
  